const healtCheck = [
    "Revisión anual con médico de cabecera",
    "Laboratorios: glucosa, trigliceridos, colesterol",
    "Revisión dental",
    "Exámen de la vista",
   "Vacuna Influenza",
   "Vacuna COVID",
   "Pruebas de detección de cancer: mastografia, antígeno prostatico, colonoscopia",
  ];
  
  export default healtCheck;
  